class LiveFeedRepository {
  constructor(Fw5MLApi) {
    this.Fw5MLApi = Fw5MLApi
  }

  async getLiveFeed(liveFeedTags) {
    if (liveFeedTags?.length > 0) {
      const req = await this.Fw5MLApi.fetch(
        `/content/articles/livefeed`,
        'POST',
        {
          isPromptLinked: true,
          sort_by: 'publication_date',
          tags: liveFeedTags
        }
      )
      return req
    } else {
      const req = await this.Fw5MLApi.fetch(
        `/content/articles/livefeed`,
        'POST',
        {
          isPromptLinked: false,
          sort_by: 'publication_date',
          content_views: [
            {
              name: 'lead article'
            },
            {
              name: 'top stories'
            },
            {
              name: 'insight analysis and views'
            },
            {
              name: 'conference news'
            }
          ],
          tags_category_operator: 'AND'
        }
      )
      return req
    }
  }
}

export default LiveFeedRepository
